module.exports = __webpack_public_path__ + "static/skillsPage-2d1a279ee5c12674a6fa45839a6d9118.jpg";